import React from 'react'
import _ from 'lodash'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountRuleState } from './types'
import {
	RuleSummaryEligibleProducts,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'

export function ProductDiscountConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<ProductDiscountRuleState>) {
	const names = _.uniq(rule.products.map((p) => {
		const row = rule.purchasedProducts.find((x) => x.productKey === p.productKey)
		return row?.productName || p.productKey
	}))

	return (
		<>
			<RuleSummaryMechanicsRow>
				<RuleSummaryStatBadge
					value={`−${rule.discount}%`}
					caption="sur produits ciblés"
					tone="accent"
					minWidth={72}
				/>
			</RuleSummaryMechanicsRow>
			<RuleSummaryEligibleProducts names={names} />
		</>
	)
}
